import type { ReactNode } from "react";
import { CommandPalette } from "@/components/common/command-palette";
import { ToastContainer } from "@/components/toast-container";
import { NewLookHeader } from "./header";
import { NewLookMenu } from "./menu";
import { PhoneTabs } from "./phone-tabs";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

/**
 * The frame around every page while "Try the new look" is on
 * (docs/new-look/PLAN.md, step 0.2). Pages that haven't been rebuilt yet
 * render inside it unchanged.
 */
export function NewLookFrame({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile();

  return (
    <div data-new-look="" className="flex min-h-screen flex-col bg-background pb-safe">
      <NewLookHeader isMobile={isMobile} />

      <main
        className={cn(
          "mx-auto w-full max-w-[1280px] flex-1",
          isMobile ? "px-4 pb-28 pt-4" : "px-8 pb-24 pt-6"
        )}
      >
        {children}
      </main>

      {isMobile ? <PhoneTabs /> : <NewLookMenu />}
      <CommandPalette />
      <ToastContainer />
    </div>
  );
}
